export type CropPixels = {
  x: number
  y: number
  width: number
  height: number
}

function loadImage(src: string): Promise<HTMLImageElement> {
  return new Promise((resolve, reject) => {
    const img = new Image()
    img.addEventListener('load', () => resolve(img))
    img.addEventListener('error', (e) => reject(e))
    img.crossOrigin = 'anonymous'
    img.src = src
  })
}

export async function getCroppedImageFile(
  imageSrc: string,
  pixelCrop: CropPixels,
  fileName = 'photo.jpg',
  mimeType = 'image/jpeg',
  quality = 0.92,
): Promise<File> {
  const image = await loadImage(imageSrc)
  const canvas = document.createElement('canvas')
  const ctx = canvas.getContext('2d')
  if (!ctx) throw new Error('Could not crop photo')

  canvas.width = pixelCrop.width
  canvas.height = pixelCrop.height

  ctx.drawImage(
    image,
    pixelCrop.x,
    pixelCrop.y,
    pixelCrop.width,
    pixelCrop.height,
    0,
    0,
    pixelCrop.width,
    pixelCrop.height,
  )

  const blob = await new Promise<Blob>((resolve, reject) => {
    canvas.toBlob(
      (b) => (b ? resolve(b) : reject(new Error('Could not export cropped photo'))),
      mimeType,
      quality,
    )
  })

  return new File([blob], fileName, { type: mimeType })
}

export async function fileToObjectUrl(file: File): Promise<string> {
  return URL.createObjectURL(file)
}

export async function urlToObjectUrl(url: string): Promise<string> {
  const res = await fetch(url, { credentials: 'include' })
  if (!res.ok) throw new Error('Could not load photo for editing')
  const blob = await res.blob()
  return URL.createObjectURL(blob)
}
